export default "__VITE_ASSET__DRNJFp4a__"